module.exports = __webpack_public_path__ + "img/delivery2.6ff33287.jpg";